var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpPcGuideWrittenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 2.3125,
    width: 8,
    height: 8,
    rx: 2,
    stroke: "#05073C",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.8125L7 1.8125C7 2.75531 7 3.22671 6.70711 3.51961C6.70711 3.51961 6.70711 3.51961 6.70711 3.51961C6.41421 3.8125 5.94281 3.8125 5 3.8125V3.8125C4.05719 3.8125 3.58579 3.8125 3.29289 3.51961C3.29289 3.51961 3.29289 3.51961 3.29289 3.51961C3 3.22671 3 2.75531 3 1.8125L3 0.812502",
    stroke: "#05073C",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 6.8125L6.5 6.8125",
    stroke: "#05073C",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpPcGuideWrittenIcon);
export default __webpack_public_path__ + "static/media/cp-pc-guide-written-icon.15e27e9aadee528b17af2d55d09a6da6.svg";
export { ForwardRef as ReactComponent };